export const STORAGE_TOKEN_KEY = 'access_token'
export const STORAGE_LANG_KEY = 'lang'
export const STORAGE_USER_INFO_KEY = 'user_info'
export const REMEMBER_CREDENTIALS_KEY = 'remembered_credentials'
export const ACTIVE_BANNER_KEY = 'active_data' // 活动列表
